"use strict";

document.addEventListener("DOMContentLoaded", function () {
  document.body.classList.add('dom-is-loaded');
});